/* ============================================================
   MAA NA NASTA — Shopify theme JS
   Visual effects (ported) + cart/variant/AJAX logic
   ============================================================ */
(function () {
  'use strict';

  /* ─── Floating particles ─── */
  function initParticles() {
    var layer = document.getElementById('particles');
    if (!layer) return;
    var colors = ['#F4900C', '#E8A020', '#C0392B', '#6B4226', '#F9EDD0'];
    for (var i = 0; i < 18; i++) {
      var p = document.createElement('div');
      p.className = 'particle';
      var size = Math.random() * 10 + 4;
      p.style.cssText =
        'width:' + size + 'px;height:' + size + 'px;background:' +
        colors[Math.floor(Math.random() * colors.length)] +
        ';left:' + (Math.random() * 100) + '%;animation-duration:' +
        (Math.random() * 12 + 10) + 's;animation-delay:' + (Math.random() * 10) + 's;opacity:0;';
      layer.appendChild(p);
    }
  }

  /* ─── Scroll reveal ─── */
  function initReveal() {
    var els = document.querySelectorAll('.reveal, .process-step');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('visible'); });
      return;
    }
    var arr = Array.prototype.slice.call(els);
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var idx = arr.indexOf(entry.target) % 3;
          setTimeout(function () { entry.target.classList.add('visible'); }, idx * 100);
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    els.forEach(function (el) { obs.observe(el); });
  }

  /* ─── 3D card tilt ─── */
  function initTilt() {
    document.querySelectorAll('.product-card').forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform =
          'translateY(-12px) rotateX(' + (-y * 8) + 'deg) rotateY(' + (x * 8) + 'deg) scale(1.02)';
      });
      card.addEventListener('mouseleave', function () { card.style.transform = ''; });
    });
  }

  /* ─── Navbar shadow on scroll ─── */
  function initNavScroll() {
    var nav = document.querySelector('nav.site-nav');
    if (!nav) return;
    window.addEventListener('scroll', function () {
      nav.style.boxShadow = window.scrollY > 60 ? '0 4px 30px rgba(44,26,14,0.12)' : 'none';
    });
  }

  /* ─── Mobile menu ─── */
  function initMobileMenu() {
    var toggle = document.querySelector('.nav-toggle');
    var menu = document.getElementById('MobileMenu');
    var close = document.querySelector('.mobile-menu-close');
    if (!toggle || !menu) return;
    toggle.addEventListener('click', function () { menu.classList.add('open'); });
    if (close) close.addEventListener('click', function () { menu.classList.remove('open'); });
    menu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { menu.classList.remove('open'); });
    });
  }

  /* ─── Cart count refresh ─── */
  function refreshCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.nav-cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      })
      .catch(function () {});
  }

  /* ─── Quick add (grid + cards) ─── */
  function initQuickAdd() {
    document.querySelectorAll('[data-quick-add]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var id = btn.getAttribute('data-quick-add');
        if (!id) return;
        var original = btn.textContent;
        btn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: id, quantity: 1 })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            btn.textContent = '✓';
            btn.style.background = '#2E7D32';
            refreshCartCount();
            setTimeout(function () {
              btn.textContent = original;
              btn.style.background = '';
              btn.disabled = false;
            }, 1200);
          })
          .catch(function () { btn.disabled = false; });
      });
    });
  }

  /* ─── Product page: gallery, variants, qty, add to cart ─── */
  function initProductPage() {
    var root = document.querySelector('[data-product-json]');
    if (!root) return;
    var product;
    try { product = JSON.parse(root.textContent); } catch (e) { return; }

    var form = document.querySelector('[data-product-form]');
    var idInput = form ? form.querySelector('[name="id"]') : null;
    var priceEl = document.querySelector('[data-pdp-price]');
    var compareEl = document.querySelector('[data-pdp-compare]');
    var addBtn = form ? form.querySelector('[data-add-btn]') : null;
    var feedback = document.querySelector('[data-cart-feedback]');
    var selected = {};

    // init from first available variant
    var firstAvail = product.variants.find(function (v) { return v.available; }) || product.variants[0];
    if (firstAvail) {
      (product.options || []).forEach(function (opt, i) {
        selected[i] = firstAvail['option' + (i + 1)];
      });
    }

    function moneyFormat(cents) {
      var sym = (window.MNN && window.MNN.moneySymbol) || '₹';
      return sym + (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    }

    function currentVariant() {
      return product.variants.find(function (v) {
        return (product.options || []).every(function (opt, i) {
          return v['option' + (i + 1)] === selected[i];
        });
      });
    }

    function updateUI() {
      var v = currentVariant();
      // pill states
      document.querySelectorAll('[data-opt-index]').forEach(function (pill) {
        var idx = parseInt(pill.getAttribute('data-opt-index'), 10);
        var val = pill.getAttribute('data-opt-value');
        pill.classList.toggle('active', selected[idx] === val);
      });
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = moneyFormat(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = moneyFormat(v.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? 'Add to Cart 🛒' : 'Sold Out';
      }
    }

    document.querySelectorAll('[data-opt-index]').forEach(function (pill) {
      pill.addEventListener('click', function () {
        if (pill.classList.contains('unavailable')) return;
        var idx = parseInt(pill.getAttribute('data-opt-index'), 10);
        selected[idx] = pill.getAttribute('data-opt-value');
        updateUI();
      });
    });

    // qty
    var qtyInput = document.querySelector('[data-qty-input]');
    document.querySelectorAll('[data-qty-btn]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qtyInput) return;
        var val = parseInt(qtyInput.value, 10) || 1;
        val += b.getAttribute('data-qty-btn') === 'plus' ? 1 : -1;
        if (val < 1) val = 1;
        qtyInput.value = val;
      });
    });

    // gallery
    document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-thumb');
        var main = document.querySelector('[data-main-media] img');
        if (main && src) main.src = src;
        document.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });

    // add to cart
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var v = currentVariant();
        if (!v || !v.available) return;
        var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Adding…'; }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: v.id, quantity: qty })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            if (feedback) feedback.textContent = '✓ Added to your order!';
            refreshCartCount();
            if (addBtn) { addBtn.disabled = false; addBtn.textContent = 'Add to Cart 🛒'; }
          })
          .catch(function () {
            if (addBtn) { addBtn.disabled = false; addBtn.textContent = 'Add to Cart 🛒'; }
          });
      });
    }

    updateUI();
  }

  /* ─── Accordion ─── */
  function initAccordion() {
    document.querySelectorAll('.pdp-acc-head').forEach(function (head) {
      head.addEventListener('click', function () {
        head.parentElement.classList.toggle('open');
      });
    });
  }

  /* ─── Review photos: 3D coverflow carousel ─── */
  function initReviewCarousel() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('[data-rp-section]').forEach(function (section) {
      var track = section.querySelector('[data-rp-track]');
      var cards = Array.prototype.slice.call(section.querySelectorAll('[data-rp-card]'));
      if (!track || cards.length === 0) return;

      var stage = section.querySelector('[data-rp-stage]');
      var prevBtn = section.querySelector('[data-rp-prev]');
      var nextBtn = section.querySelector('[data-rp-next]');
      var dotsWrap = section.querySelector('[data-rp-dots]');
      var n = cards.length;
      var active = 0;
      var timer = null;

      // build dots
      var dots = [];
      if (dotsWrap) {
        cards.forEach(function (_, i) {
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'rp-dot';
          d.setAttribute('aria-label', 'Go to review ' + (i + 1));
          d.addEventListener('click', function () { go(i); restart(); });
          dotsWrap.appendChild(d);
          dots.push(d);
        });
      }

      function styleFor(off) {
        var abs = Math.abs(off);
        var sign = off < 0 ? -1 : 1;
        if (abs > 2) {
          return { t: 'translateX(' + (sign * 180) + '%) translateZ(-320px) scale(0.5)', o: 0, z: 0, pe: 'none' };
        }
        if (off === 0) {
          return { t: 'translateX(0) translateZ(60px) rotateY(0deg) scale(1)', o: 1, z: 30, pe: 'auto' };
        }
        if (abs === 1) {
          return { t: 'translateX(' + (sign * 62) + '%) translateZ(-55px) rotateY(' + (-sign * 38) + 'deg) scale(0.84)', o: 0.72, z: 20, pe: 'auto' };
        }
        return { t: 'translateX(' + (sign * 112) + '%) translateZ(-175px) rotateY(' + (-sign * 42) + 'deg) scale(0.66)', o: 0.32, z: 10, pe: 'none' };
      }

      function render() {
        cards.forEach(function (card, i) {
          var off = i - active;
          if (off > n / 2) off -= n;
          if (off < -n / 2) off += n;
          var s = styleFor(off);
          card.style.transform = s.t;
          card.style.opacity = s.o;
          card.style.zIndex = s.z;
          card.style.pointerEvents = s.pe;
          card.classList.toggle('rp-active', off === 0);
        });
        dots.forEach(function (d, i) { d.classList.toggle('rp-dot--active', i === active); });
      }

      function go(i) { active = ((i % n) + n) % n; render(); }
      function next() { go(active + 1); }
      function prev() { go(active - 1); }

      // click a side card to bring it forward
      cards.forEach(function (card, i) {
        card.addEventListener('click', function () {
          if (i !== active) { go(i); restart(); }
        });
      });

      if (nextBtn) nextBtn.addEventListener('click', function () { next(); restart(); });
      if (prevBtn) prevBtn.addEventListener('click', function () { prev(); restart(); });

      // drag / swipe
      var startX = 0, dragging = false;
      function down(x) { startX = x; dragging = true; if (stage) stage.classList.add('rp-dragging'); stop(); }
      function up(x) {
        if (!dragging) return;
        dragging = false;
        if (stage) stage.classList.remove('rp-dragging');
        var dx = x - startX;
        if (Math.abs(dx) > 45) { if (dx < 0) next(); else prev(); }
        restart();
      }
      if (stage) {
        stage.addEventListener('mousedown', function (e) { down(e.clientX); });
        window.addEventListener('mouseup', function (e) { up(e.clientX); });
        stage.addEventListener('touchstart', function (e) { down(e.touches[0].clientX); }, { passive: true });
        stage.addEventListener('touchend', function (e) { up((e.changedTouches[0] || {}).clientX || startX); });
        stage.addEventListener('mouseenter', stop);
        stage.addEventListener('mouseleave', start);
      }

      // keyboard
      section.setAttribute('tabindex', '-1');
      section.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { prev(); restart(); }
        else if (e.key === 'ArrowRight') { next(); restart(); }
      });

      // autoplay
      function start() { if (reduce || n <= 1 || timer) return; timer = setInterval(next, 5000); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function restart() { stop(); start(); }

      render();
      start();
    });
  }

  /* ─── Init all ─── */
  document.addEventListener('DOMContentLoaded', function () {
    initParticles();
    initReveal();
    initTilt();
    initNavScroll();
    initMobileMenu();
    initQuickAdd();
    initProductPage();
    initAccordion();
    initReviewCarousel();
    refreshCartCount();
  });
})();
